import React from 'react'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import moment from 'moment-timezone'
import { MDBDataTableV5, MDBIcon } from 'mdbreact'
import '@fortawesome/fontawesome-free/css/all.min.css'
import classnames from 'classnames'

class ProcessOrder extends React.Component {
  _isMounted = true
  orderStatus = sessionStorage.getItem('processStatus')
  orderState = sessionStorage.getItem('processState')
  constructor(props) {
    super(props)
    this.state = {
      tabList: [{ name: 'Attention' }, { name: 'Process' }, { name: 'Payment' }, { name: 'Quotation' }],
      status: this.orderStatus ? this.orderStatus : 'Attention',
      state: this.orderState ? this.orderState : 'Default',
      stateList: [],
      activeTab: '1',
      orderList: [],
      filterList: [],
    }
  }

  changeHandler = e => {
    let { name, value } = e.target
    this.setState({
      [name]: value,
    })

    this.getOrder(value.toLowerCase())
    sessionStorage.setItem('processStatus', value)
  }

  stateHandler = e => {
    let { name, value } = e.target
    this.setState({
      [name]: value,
    })

    this.filterOrder(value)
    sessionStorage.setItem('processState', value)
  }

  componentDidMount() {
    this.getOrder(this.state.status)
    this.getOrderState()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  getOrder(type) {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.props.state.store_id,
      limit: 100,
      days: 100,
    }

    axios
      .post(url + ':3003/v1/order/' + type, data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          for (let i of result.data) {
            if (i.order_dt) {
              i.order_dt = moment(i.order_dt).tz('Asia/Singapore').format('YYYY-MM-DD')
            }
            if (i.invoice_no === null) {
              i.invoice_no = ''
            }
            if (i.total_tax) {
              i.total_tax = parseFloat(i.total_tax).toFixed(2)
            }
            i.Action = (
              <div className="ps-action-button">
                <Button className="theme-button theme-button-secondary" onClick={() => this.props.order(i.order_id)}>
                  View
                </Button>
              </div>
            )
          }

          this.setState({
            orderList: result.data,
            filterList: this.state.status === 'Process' && this.state.state != 'Default' ? result.data.filter(x => x.order_status == this.state.state) : result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getOrderState() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3003/v1/order/state', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        let stateList = result.data.filter(x => x.order_section === 'Process')
        if (this._isMounted) {
          this.setState({
            stateList: stateList,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  filterOrder(state) {
    let data
    if (state === 'Default') {
      data = this.state.orderList
    } else {
      data = this.state.orderList.filter(x => x.order_status == state)
    }
    this.setState({
      filterList: data,
    })
  }

  order = id => {
    this.props.history.push({
      pathname: '/posorder/store/' + this.state.store_id + '/' + id,
    })
  }

  render() {
    const { activeTab } = this.state
    const data = {
      columns: this.props.tbcolumn,
      rows: this.state.filterList,
    }
    return (
      <>
        <Row>
          <Col sm={3}>
            <Input className="ps-input-small" type="select" name="status" value={this.state.status} onChange={this.changeHandler}>
              {this.state.tabList.map(item => {
                return (
                  <option key={item.name} value={item.name}>
                    {item.name}
                  </option>
                )
              })}
            </Input>
          </Col>
          {this.state.status === 'Process' && (
            <Col sm={3}>
              <Input className="ps-input-small ps-input-fit" type="select" name="state" value={this.state.state} onChange={this.stateHandler}>
                <option value="Default">Default</option>
                {this.state.stateList.map(item => {
                  return (
                    <option key={item.id} value={item.name}>
                      {item.name}
                    </option>
                  )
                })}
              </Input>
            </Col>
          )}
        </Row>
        <MDBDataTableV5 className="ps-order-table th-11" data={data} displayEntries={false} searchTop searchBottom={false} noRecordsFoundLabel="No data to show" fullPagination disableRetreatAfterSorting={true} responsive />
      </>
    )
  }
}

export default ProcessOrder
